import { Button, Checkbox, Input, Popconfirm, message } from "antd";
import axios from "axios";
import React, { useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";
import SelectAccounts from "./selectAccounts.js";
const { TextArea } = Input;

function ComplaintAdEligible(props) {
  const [loading, setLoading] = useState(false);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [mccId, setMccId] = useState('');
  const [mccList, setMccList] = useState([]);
  const [accounts, setAccounts] = useState('');
  const [runAll, setRunAll] = useState(false);
  
  const [messageApi, contextHolder] = message.useMessage();

  const create = async (profile) => {
    messageApi.info(`Profile: ${profile.name} >>> Kháng Ad Eligible...`);
    let body = {
      profile: profile,
      mccId: mccList?.length > 0 ? mccList[0] : mccId,
      mccList: mccList?.length > 0 ? mccList : [mccId],
      listId: accounts,
      runAll: runAll
    };
    axios
      .post(`${API_HOST}/api/account/complaint-ad-eligible`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Kháng Ad Eligible ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ minWidth: 500 }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Kháng Ad Eligible"
        description={
          <>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
            <br />
            <label>Nhập MCC ID (Nếu có nhiều TK MCC):</label><br />
              <Input style={{width: 300}}
                  placeholder="MCC ID"
                  onChange={(e) => setMccId(e.target.value ) }
              />
              <br />
              <SelectAccounts selectAccounts={profileModel?.selectAccounts}
                onSelected={(selected) => setMccList(selected)}
              />
              <br />
              <br />
              <Checkbox checked={runAll} onChange={e => setRunAll(e.target.checked)}>
                <b>Chạy Toàn Bộ TK con</b>
              </Checkbox>
              <br />
              <label>Nhập ID Tài khoản <i style={{color:'red'}}>(Mỗi ID 1 dòng)</i>
              </label>
              <br />
              <TextArea rows={5} 
                    value={accounts} 
                    onChange={(e) => setAccounts(e.target.value)} 
              />
          </>
        }
        onConfirm={() => create(props.profile)}
      >
        <Button danger loading={loading}>
          Kháng Ad Eligible
        </Button>
      </Popconfirm>
    </>
  );
}
export default ComplaintAdEligible;
